import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Scheduler from './icon-scheduler.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Scheduler {...validProps} />;
}
SvgComponent.iconName = 'scheduler';

/**
 * @deprecated This is a legacy icon
 */
export const SchedulerIcon = svgIconWrapper(SvgComponent);
